<template>
  <v-footer color="primary" class="enr-footer py-0">
    <footer class="footer">
      <v-container>
        <v-layout>
          <v-container>
            {{ $store.getters["frontend/organisation"].name }} -
            <a class="email" :href="'mailto:' + this.$store.getters['frontend/organisation'].email">{{
              $store.getters["frontend/organisation"].email
            }}</a>
          </v-container>
        </v-layout>
      </v-container>
    </footer>
  </v-footer>
</template>

<script>
export default {
  name: "vue-footer"
}
</script>
